module.exports = __webpack_public_path__ + "static/media/dehanee.2be9fc90.png";